var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[
    'icon-button',
    _vm.sizeClass,
    _vm.colorClass,
  ],attrs:{"title":_vm.title,"disabled":_vm.disabled ? 'disabled' : false},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }